module.exports = __webpack_public_path__ + "assets/id-icon.86e4ec31.svg";